module.exports = "<div class=\"container\">\n  <div class=\"message\">\n    {{ message | uppercase | translate }}\n  </div>\n  <app-card-pay *ngIf=\"message=='hold_declined' || message=='hold_approved'\" [order]=\"order\" [amount]=\"data.amount\"></app-card-pay>\n  <mat-spinner class=\"loader\" *ngIf=\"showSpinner\"></mat-spinner>\n  <button *ngIf=\"!showSpinner\" class=\"button\" mat-raised-button mat-dialog-close>\n    {{ 'OK' | translate }}\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/card-payment/card-payment.component.html
// module id = ./src/app/dashboard/card-payment/card-payment.component.html
// module chunks = main